var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-879dd9b0"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "modal__content content" };
var _hoisted_2 = { class: "text-center text-xl leading-6 font-medium" };
var _hoisted_3 = { class: "text-center mt-4 text-gray-400" };
var _hoisted_4 = { class: "space-y-4 form" };
import { useI18n } from 'vue-i18n';
import getClientFingerprint from '@common/utils/ClientFingerprint';
import { apiErrorsHandle } from '@common/utils/Helpers/Helpers';
import Auth from '@common/modules/auth';
import passData from '@common/utils/PassData';
import { AuthModalStore } from '@student/modules/store';
import Message from '@common/ui/EMessage/Message';
import { nextTick, onMounted, ref } from 'vue';
import { AuthRoles } from '@common/interfaces/utils';
import { useForm, useIsFormDirty } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import EInputField from '@common/ui/EForm/fields/EInputField.vue';
import { storageSession } from '@common/utils/Storage/Storage';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegisterModalByLink',
    setup: function (__props) {
        var _this = this;
        var regToken = ref(null);
        var visible = ref(false);
        var formLoading = ref(false);
        var t = useI18n().t;
        var _a = useForm({
            validationSchema: toTypedSchema(z.object({
                password: z.string()
                    .min(1, t('errors.enterPassword'))
                    .min(8, t('errors.passwordMinLength'))
                    .refine(function (v) { return !/\s/.test(v); }, t('errors.noSpaces')),
                passwordRepeat: z.string()
                    .min(1, t('errors.repeatPassword'))
            }).refine(function (data) { return data.password === data.passwordRepeat; }, {
                message: t('errors.passwordsMismatch'),
                path: ['passwordRepeat'],
            }))
        }), handleSubmit = _a.handleSubmit, values = _a.values, setValues = _a.setValues;
        var isDirty = useIsFormDirty();
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        regToken.value = new URLSearchParams(window.location.search).get('registerToken') || new URLSearchParams(window.location.search).get('token') || null;
                        if (!(regToken.value && !passData.registerTokenValid)) return [3 /*break*/, 2];
                        if (Auth.isGuest()) {
                            AuthModalStore.showLogin();
                        }
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        Message.error(t('errors.linkUsed'));
                        return [2 /*return*/];
                    case 2:
                        if (regToken.value) {
                            visible.value = true;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        var hideModal = function () {
            visible.value = false;
            // Удаляем параметр из ссылки без перезагрузки
            window.history.replaceState('', '/', window.location.pathname);
        };
        var submitForm = handleSubmit(function (values, ctx) { return __awaiter(_this, void 0, void 0, function () {
            var fingerprint, res, data, currentPath, isSaveCurrentLocation, isMustReload, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formLoading.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, getClientFingerprint()];
                    case 2:
                        fingerprint = _a.sent();
                        return [4 /*yield*/, Auth.registerByToken({
                                password: values.password,
                                registerToken: regToken.value,
                                fingerprint: fingerprint
                            })];
                    case 3:
                        res = _a.sent();
                        data = res.data;
                        currentPath = window.location.pathname;
                        isSaveCurrentLocation = currentPath.includes('course') || currentPath.includes('stream');
                        if (isSaveCurrentLocation) {
                            storageSession.set('routeToRedirectAfterAuth', {
                                fullPath: currentPath,
                            });
                        }
                        hideModal();
                        isMustReload = (data.user.role && data.user.role !== AuthRoles.ROLE_STUDENT) || currentPath.includes('course');
                        if (isMustReload) {
                            Auth.restoreSavedLocation(true);
                        }
                        else {
                            Auth.restoreSavedLocation();
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        apiErrorsHandle(err_1, { 'USER_NOT_FOUND': t('errors.linkExpired') });
                        return [3 /*break*/, 6];
                    case 5:
                        formLoading.value = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _component_e_button = _resolveComponent("e-button");
            var _component_e_dialog = _resolveComponent("e-dialog");
            return (_openBlock(), _createBlock(_component_e_dialog, {
                visible: visible.value,
                class: "modal",
                name: "register-modal-by-link",
                "forcibly-hide-body": "",
                onClose: hideModal
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('modal.setPassword')), 1),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('modal.enterPasswordHint')), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(EInputField, {
                                placeholder: _unref(t)('modal.createPassword'),
                                plugins: ['trim'],
                                name: "password",
                                type: "password",
                                autocomplete: ""
                            }, null, 8, ["placeholder"]),
                            _createVNode(EInputField, {
                                placeholder: _unref(t)('modal.repeatPassword'),
                                plugins: ['trim'],
                                name: "passwordRepeat",
                                type: "password",
                                autocomplete: "",
                                "show-password": ""
                            }, null, 8, ["placeholder"])
                        ]),
                        _createVNode(_component_e_button, {
                            disabled: !_unref(isDirty),
                            loading: formLoading.value,
                            class: "mt-4",
                            type: "primary",
                            onClick: _unref(submitForm)
                        }, {
                            default: _withCtx(function () { return [
                                _createTextVNode(_toDisplayString(_unref(t)('modal.register')), 1)
                            ]; }),
                            _: 1
                        }, 8, ["disabled", "loading", "onClick"])
                    ])
                ]; }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
